import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';

import { DIRECTIONS, SIZES } from './constants';

export { DIRECTIONS, SIZES };

const Chevron = ({ direction, isActive, fillColor, size }) => {
  const ChevronClass = classNames(`Chevron Chevron--${direction}`, {
    'Chevron--active': isActive,
  });

  return (
    <span className={ChevronClass}>
      <style jsx>
        {`
          .Chevron {
            display: inline-block;
            width: ${(size * 4) / 3}px;
            height: ${(size * 4) / 3}px;
            border-bottom: ${size / 3}px solid ${Theme.get(fillColor)};
            border-right: ${size / 3}px solid ${Theme.get(fillColor)};
            transition: all ease-in-out ${Theme.get('transition-duration-ms')};
          }

          .Chevron--${DIRECTIONS.DOWN} {
            transform: rotate(45deg);
            margin-bottom: ${size / 2}px;
          }

          .Chevron--${DIRECTIONS.LEFT} {
            transform: rotate(135deg);
            margin-left: ${size / 2}px;
          }

          .Chevron--${DIRECTIONS.UP} {
            transform: rotate(225deg);
            margin-top: ${size / 2}px;
          }

          .Chevron--${DIRECTIONS.RIGHT} {
            transform: rotate(-45deg);
            margin-right: ${size / 2}px;
          }

          .Chevron--${DIRECTIONS.DOWN}.Chevron--active {
            transform: rotate(0);
            border-right: 0;
          }
        `}
      </style>
    </span>
  );
};

Chevron.propTypes = {
  direction: PropTypes.oneOf(Object.values(DIRECTIONS)),
  isActive: PropTypes.bool,
  fillColor: PropTypes.string,
  size: PropTypes.oneOf(Object.values(SIZES)),
};

Chevron.defaultProps = {
  direction: DIRECTIONS.DOWN,
  isActive: false,
  fillColor: 'colors-black',
  size: SIZES.MEDIUM,
};

export default Chevron;
